import { render, staticRenderFns } from "./CoverBtn.vue?vue&type=template&id=4172c2a0&"
import script from "./CoverBtn.vue?vue&type=script&lang=js&"
export * from "./CoverBtn.vue?vue&type=script&lang=js&"
import style0 from "./CoverBtn.vue?vue&type=style&index=0&id=4172c2a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports